var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDollarFill(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49935 0.416016C3.58935 0.416016 0.416016 3.58935 0.416016 7.49935C0.416016 11.4093 3.58935 14.5827 7.49935 14.5827C11.4093 14.5827 14.5827 11.4093 14.5827 7.49935C14.5827 3.58935 11.4093 0.416016 7.49935 0.416016ZM8.12268 11.5793V12.4577H6.8831V11.5439C6.35893 11.4164 5.19018 10.9985 4.74393 9.44726L5.91268 8.97268C5.95518 9.12851 6.32351 10.4531 7.61268 10.4531C8.27143 10.4531 9.01518 10.1131 9.01518 9.31268C9.01518 8.63268 8.51935 8.27851 7.40018 7.87476C6.62101 7.59851 5.02726 7.14518 5.02726 5.53018C5.02726 5.45935 5.03435 3.83018 6.8831 3.43352V2.54102H8.12268V3.41935C9.42601 3.64601 9.9006 4.68726 10.0068 4.99893L8.88768 5.47351C8.80976 5.2256 8.46976 4.52435 7.54185 4.52435C7.04601 4.52435 6.25976 4.78643 6.25976 5.50893C6.25976 6.18185 6.86893 6.43685 8.12976 6.85476C9.82976 7.44268 10.2618 8.30685 10.2618 9.29851C10.2618 11.1614 8.49101 11.5156 8.12268 11.5793Z",
    fill: "#303030"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarFill);
export default __webpack_public_path__ + "static/media/dollar-fill.a8daab7afdb9e8d5c34be4e829b6a756.svg";
export { ForwardRef as ReactComponent };